import { CATEGORIES } from "./categories.js";

export function parseCategorizationCsv(text) {
  const lines = text.replace(/^\uFEFF/, "").split(/\r?\n/).filter((line) => line.length > 0);
  if (lines.length < 2) {
    throw new Error("CSV is empty.");
  }
  const header = splitCsvLine(lines[0]);
  const wordIndex = header.indexOf("word");
  if (wordIndex < 0) {
    throw new Error("CSV is missing the word column.");
  }
  const columnIndex = {};
  for (const key of CATEGORIES) {
    const index = header.indexOf(key);
    if (index < 0) {
      throw new Error(`CSV is missing category column: ${key}`);
    }
    columnIndex[key] = index;
  }

  const rows = [];
  const seen = new Set();
  for (let i = 1; i < lines.length; i += 1) {
    const cols = splitCsvLine(lines[i]);
    const word = (cols[wordIndex] || "").trim();
    if (!word) continue;
    if (seen.has(word)) {
      throw new Error(`Duplicate word at row ${i + 1}: ${word}`);
    }
    seen.add(word);
    const scores = {};
    let total = 0;
    for (const key of CATEGORIES) {
      const value = Number(cols[columnIndex[key]]);
      if (!Number.isFinite(value) || value < 0 || value > 100) {
        throw new Error(`Invalid ${key} score for ${word}`);
      }
      scores[key] = value;
      total += value;
    }
    if (Math.abs(total - 100) > 0.2) {
      throw new Error(`Scores for ${word} sum to ${total.toFixed(2)}, not 100`);
    }
    rows.push({ word, scores });
  }
  return rows;
}

function splitCsvLine(line) {
  const out = [];
  let current = "";
  let quoted = false;
  for (let i = 0; i < line.length; i += 1) {
    const ch = line[i];
    if (quoted) {
      if (ch === '"') {
        if (line[i + 1] === '"') {
          current += '"';
          i += 1;
        } else {
          quoted = false;
        }
      } else {
        current += ch;
      }
    } else if (ch === '"') {
      quoted = true;
    } else if (ch === ",") {
      out.push(current);
      current = "";
    } else {
      current += ch;
    }
  }
  out.push(current);
  return out;
}
